import React from "react"
import ReactDOM from 'react-dom';

export class InfoMessage extends React.Component {

  constructor(props) {
    super(props);
  }

  render () {
    return (
      <div className="alert alert-info">
        {this.props.message.split('\n').map((item, key) => {
          return <span key={key}>{item}<br/></span>
        })}
      </div>
    );
  }
}
